import {Modal, Button} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'

interface Props {
  show: boolean
  workflowName?: string
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const ModalDeleteWorkflow: React.FC<Props> = ({
  show,
  workflowName,
  onClose,
  onConfirm,
  loading,
}) => {
  const intl = useIntl()
  const handleConfirm = () => {
    if (
      window.confirm(intl.formatMessage({id: 'leads.kanban.deleteBoardConfirm', defaultMessage: 'Deleting this board will permanently remove all its columns and tasks. Are you sure you want to proceed?'}))
    ) {
      onConfirm()
    }
  }

  return (
    <Modal show={show} onHide={onClose} centered className='kanban-delete-workflow-modal'>
      <Modal.Header closeButton className='kanban-delete-workflow-modal__header'>
        <Modal.Title><FormattedMessage id='leads.kanban.deleteBoard' defaultMessage='Delete Board' /></Modal.Title>
      </Modal.Header>
      <Modal.Body className='kanban-delete-workflow-modal__body'>
        <p>
          {intl.formatMessage({id: 'leads.kanban.deleteBoardBody', defaultMessage: 'Are you sure you want to delete the board <b>{name}</b>? This action cannot be undone and all associated columns and tasks will be permanently deleted.'}, {name: workflowName ?? '', b: (chunks: (string | JSX.Element)[]) => <strong>{chunks}</strong>})}
        </p>
      </Modal.Body>
      <Modal.Footer className='kanban-delete-workflow-modal__footer'>
        <Button variant='light' onClick={onClose} disabled={loading}>
          <FormattedMessage id='common.action.cancel' defaultMessage='Cancel' />
        </Button>
        <Button variant='danger' onClick={handleConfirm} disabled={loading}>
          {loading ? intl.formatMessage({id: 'leads.kanban.deleting', defaultMessage: 'Deleting...'}) : intl.formatMessage({id: 'leads.kanban.deleteBoard', defaultMessage: 'Delete Board'})}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
